import { createTheme } from '@mui/material'

import { components } from './components'
import { componentsOverrides as legacyComponents } from './legacy.overrides'
import { palette } from './palette'
import { shadows } from './shadows'
import { typography } from './typography'

export const cybusTheme = createTheme({
    spacing: 4,
    typography,
    palette,
    shadows,
    components: {
        ...legacyComponents,
        ...components,
    },
    breakpoints: {
        values: {
            xs: 0,
            sm: 600,
            md: 900,
            /** Original value was 1200 */
            lg: 1280,
            xl: 1536,
        },
    },
})
